import * as React from "react";
import { App } from "./app"

interface ScrollToTopButtonVm {
    app: App
}

interface ButtonState {
    hoverState: string
}

/* ScrollToTopButton is a conditionally shown and positionally fixed transparent button that helps the user to return to top of the page */
export class ScrollToTopButton extends React.Component<ScrollToTopButtonVm, ButtonState> {
    // 
    constructor(props: ScrollToTopButtonVm) {
        super(props)
        this.m_scrollOpacity = 0.3
    }

    // 
    state: ButtonState = {
        hoverState: "out"
    }

    // 
    componentWillMount() {
        this.props.app.BindScrollToTopButton(this)
    }

    // Passes on clicks to a handler within Core:
    onClick() {
        this.m_scrollOpacity = 0.2
        setTimeout(this.props.app.ScrollToTop.bind(this.props.app), 100)
        this.setState({ hoverState: "out" })
    }

    // 
    OnMouseEnter() {
        this.m_scrollOpacity = 0.5
        this.setState({ hoverState: "hover" })
    }

    // 
    OnMouseLeave() {
        this.m_scrollOpacity = 0.2
        this.setState({ hoverState: "out" })
    }

    // 
    render() {
        var topPos = (window.innerHeight - 100).toString() + "px"
        var leftPos = (window.innerWidth - 100).toString() + "px"

        if (window.scrollY >= 500) {
            // Rendering the resulting button
            return (
                <div
                    onMouseEnter={this.OnMouseEnter.bind(this)}
                    onMouseLeave={this.OnMouseLeave.bind(this)}
                    onClick={this.onClick.bind(this)}
                    style={{
                        height: "54px",
                        width: "55px",
                        position: "fixed",
                        top: topPos,
                        left: leftPos,
                        backgroundImage: "url(images/top55.png)",
                        opacity: this.m_scrollOpacity
                    }}>
                </div>
            )
        }
         
        return <div></div>
    }

    private m_scrollOpacity : number
}



// WEBPACK FOOTER //
// ./client/view/ScrollToTopButton.tsx